import Snap from 'snapsvg-cjs';
import createDots from './create-dots';
import createTriangle from './create-triangle';

const sectionForm = () => {
  const bg = Snap('.js-form-anim');
  const dots = [];
  if (bg) {
    createDots(bg, 9, 17, 1300, 183, mina.easeinout, dots);
    dots[0][7].attr({
      fill: 'transparent',
    });
    dots[1][7].attr({
      fill: 'transparent',
    });
    createTriangle(bg, 130, 130, 1182, 80, 20);
    createTriangle(bg, 90, 330, 1182, 880, 30);
    createTriangle(bg, 200, 230, 1532, 800, 50);
    createTriangle(bg, 180, 310, 1182, 1020, 30);
    createTriangle(bg, 60, 240, 1550, 1080, 15);
  }
};

export default sectionForm;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-form.js